import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component } from '@eastsideco/salvo-ts';

@Component
export class TrustPilotWidget extends ThemeComponent {

    constructor() {
        super();
    }

    init() {
    }
}
